import React from 'react';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import MenuIcon from '@mui/icons-material/Menu';
import Drawer from '@mui/material/Drawer';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import CloseIcon from '@mui/icons-material/Close';
import { WhiteAppBar, DrawerContent } from '../assets/commonComponents/css/appBar';
import { COLORS, fontFamilyAll } from '../assets/commonComponents/COLORS';

function NavigationBar({ logo, isMobile, drawerOpen, toggleDrawer, handleScroll, navigationData }) {

    return (
        <>
            <WhiteAppBar position="fixed" sx={{ minHeight: 80, justifyContent: 'center' }}>
                <Toolbar sx={{ justifyContent: 'space-between', px: 2 }}>
                    {
                        !isMobile &&

                        <Box component="img" src={logo} alt="Company Logo" sx={{ height: 50 }} />
                    }
                    {isMobile ? (
                        <><IconButton edge="end" color="inherit" onClick={toggleDrawer(true)}>
                            <MenuIcon sx={{ color: "black" }} />
                        </IconButton>
                        </>
                    ) : (
                        <Box sx={{ display: 'flex', gap: 3 }}>
                            {navigationData.map((item) => (
                                <Typography
                                    key={item}
                                    onClick={() => handleScroll(item?.toLowerCase())}
                                    sx={{
                                        color: "black",
                                        fontFamily:` ${fontFamilyAll} !important`,
                                        textTransform: 'capitalize',
                                        transition: 'color 0.3s',
                                        cursor: 'pointer',
                                        '&:hover': { color: COLORS.primaryColor },
                                        '&:active': { color: COLORS.primaryColor }
                                    }}
                                >
                                    {item}
                                </Typography>

                            ))}


                        </Box>
                    )}
                    {
                        isMobile &&

                        <Box >
                            <Typography color={COLORS.secondaryColor} mr={14} textAlign={"center"} fontFamily={fontFamilyAll}>FIT FINANCE</Typography>
                        </Box>
                    }

                </Toolbar>
            </WhiteAppBar>
            <Drawer anchor="left" open={drawerOpen} onClose={toggleDrawer(false)}>
                <DrawerContent>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', width: '100%', alignItems: 'center' }}>
                        <Box component="img" src={logo} alt="Company Logo" sx={{ height: 50 }} />
                        <IconButton onClick={toggleDrawer(false)} sx={{ color: COLORS.secondaryColor }}>
                            <CloseIcon />
                        </IconButton>
                    </Box>
                    <List sx={{ mt: 4, width: '100%' }}>
                        {navigationData.map((item) => (
                            <ListItem
                                key={item}
                                onClick={() => handleScroll(item?.toLowerCase())}
                                sx={{ 
                                    fontFamily:` ${fontFamilyAll} !important`,
                                    '&:hover .MuiListItemText-primary': { fontWeight: 'bold' }, '&:active .MuiListItemText-primary': { fontWeight: 'bold' } }}
                            >
                                <ListItemText
                                    primary={item}
                                    fontFamily={fontFamilyAll}
                                    sx={{ fontFamily:` ${fontFamilyAll} !important`, color: COLORS.secondaryColor, textAlign: 'left', fontSize: '18px', transition: 'color 0.3s', cursor: 'pointer' }}
                                />
                            </ListItem>
                        ))}
                    </List>
                </DrawerContent>
            </Drawer>
        </>
    );
}

export default NavigationBar;
